<div [class.compact]="compact" class="countdown">
  <ng-container *ngFor="let unit of units(); trackBy: trackByUnitValue; let last = last; ">
    <div class="box" *translate="let t">
      <div class="number">
        <span>{{ unit.value }}</span>
      </div>
      <div class="label" *ngIf="!compact">{{ t(`time.${unit.label}`) }}</div>
    </div>
    <div class="separator" *ngIf="!last">:</div>
  </ng-container>
</div>